export default __webpack_public_path__ + "static/5-883628c1cab3a8552f3881338b63e50d.jpeg";